<template>
      <v-row dense>
        <v-col
          v-for="(tourCourse, i) in filteredTourCourses" :key="i" cols="12">
          <v-card class="elevation-13">
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title
                  class="headline">
                  <span class="mr-2">{{tourCourse.name}} <span v-if="tourCourse.timeOfDay == 'night'">({{$t('tours.' + tourCourse.timeOfDay)}})</span> - {{$t('tours.' + tourCourse.region)}}</span>
                  <TourModal :tourCourse="tourCourse"></TourModal>
                </v-card-title>
                <v-card-subtitle class="mt-1">
                  <span v-for="(destination, i) in tourCourse.itinerary">
                    <span v-if="i == tourCourse.itinerary.length - 1">
                      <v-chip>{{ $t('tours.' + destination.folderName) }}</v-chip>
                    </span>
                    <span v-else>
                      <v-chip>{{ $t('tours.' + destination.folderName) }}</v-chip><v-icon>mdi-forward</v-icon>
                    </span>
                  </span>
                </v-card-subtitle>
              </div>
              <v-avatar
                class="ma-3"
                size="125"
                tile>
                <v-img :src='getThumbnailURL(tourCourse.thumbNail)'></v-img>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
      </v-row>
</template>
<script>
import TourModal from '../modal/TourModal.vue'
export default {
  name: 'ToursCard',
  components: {
    TourModal
  },
  computed: {
    tourCourses() {
      return this.$store.getters.tourCourses;
    },
    filteredTourCourses() {
      return this.tourCourses.filter(course =>
        this.$attrs.regionFilters.includes(course.region) && this.$attrs.courseFilters.includes(course.course) && this.$attrs.timeFilters.includes(course.timeOfDay)
      )
    }
  },

  data: () => ({
  }),
  methods: {
    getThumbnailURL: function(thumbNail) {
      return require('../../assets/destinations' + thumbNail)
    }
  }
};
</script>

<style scoped>
#home-carousel {
}
</style>
